module.exports = __webpack_public_path__ + "img/project4_4.jpg.78aec20a.webp";